import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerNoteSpeseETrasferteModalComponent} from './worker-note-spese-e-trasferte-modal';

export const WorkerNoteSpeseETrasferteModalModule: string = ng
    .module('worker-note-spese-e-trasferte-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerNoteSpeseETrasferteModalComponent', WorkerNoteSpeseETrasferteModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-note-spese-e-trasferte-modal/worker-note-spese-e-trasferte-modal.module.ts